import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'antd';
import { useStore } from '../../../../cyber-security-training/store';
import './animation040.less';

import AddPointIcon from '../../../../../assets/animation-arrow.gif';
import Img817w3 from '../../../../../assets/817w3.png';
import Img817w2 from '../../../../../assets/817w2.png';
import ImgP9801 from '../../../../../assets/p9801.png';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowRight from '../../../../../assets/arrow-right.png';
import ImgArrowLeft from '../../../../../assets/arrow-left.png';

interface IAnimation040Props {
  content1: string;
  content2: string;
  content3: string;
  content4: string;
  content5: string;
  content6: string;
  className: string;
}

const Animation040: React.FunctionComponent<IAnimation040Props> = ({
  content1,
  content2,
  content3,
  content4,
  content5,
  content6,
  className,
}) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { updateParagraphState } = useStore();
  const [state, setState] = React.useState({
    step: 0,
  });
  const swithStep = (step: number) => {
    setState({
      step,
    });
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  };
  return (
    <div className={`example component ${className}`}>
      <span
        className="example-label"
        dangerouslySetInnerHTML={{ __html: content1 }}
      />
      <span className="link-label">
        <img src={AddPointIcon} alt="" />
        {content2}
      </span>
      <a
        className="example-link"
        href="https://haveibeenpwned.com/"
        target="_blank"
        rel="noreferrer"
      >
        Have I been Pwned?
      </a>
      <div className={`example-content ${state.step === 1 ? 'hide' : ''}`}>
        <img src={Img817w3} alt="" className="img-pwd" />
        <div className="example-person">
          <div className="popover-message">
            <div
              className="l1"
              dangerouslySetInnerHTML={{ __html: content3 }}
            />
            <div
              className="l2"
              dangerouslySetInnerHTML={{ __html: content4 }}
            />
          </div>
          <img className="person" src={ImgP9801} alt="" />
        </div>
        <img className="point" src={ImgPoint} alt="" />
        <Button
          className="next-button"
          type="text"
          onClick={() => swithStep(1)}
        >
          <img src={ImgArrowRight} alt="" className="img-next-button" />
        </Button>
      </div>
      <div className={`example-content ${state.step === 0 ? 'hide' : ''}`}>
        <Button
          className="prev-button"
          type="text"
          onClick={() => swithStep(0)}
        >
          <img src={ImgArrowLeft} alt="" className="img-next-button" />
        </Button>
        <img src={Img817w2} alt="" className="img-pwd2" />
        <div className="example-person">
          <div className="popover-message red">
            <div
              className="l1"
              dangerouslySetInnerHTML={{ __html: content5 }}
            />
            <div
              className="l2"
              dangerouslySetInnerHTML={{ __html: content6 }}
            />
          </div>
          <img className="person" src={ImgP9801} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Animation040;
